/**
 * user-record-list コンポーネント専用i18n定数
 */

export const USER_RECORD_LIST_I18N = {
  // パンくずリスト
  breadcrumb: {
    userList: $localize`:@@home.userRecordList.breadcrumb.userList:ユーザー一覧`,
    recordList: $localize`:@@home.userRecordList.breadcrumb.recordList:レコードリスト`,
  },
} as const;

export type UserRecordListI18n = typeof USER_RECORD_LIST_I18N;
